import { useContext, useEffect, useState } from "react";
import { Button, Form, Container } from "react-bootstrap";
import {
  Totak_Supply,
  Burn,
  Add_Minter,
  Remove_Minter,
  MintByMaster,
} from "../Web3/Methods";
import toast, { Toaster } from "react-hot-toast";
import { AppContext } from "../AppContext";
import { MasterMnModal } from "./MasterMintBurn";
import { useActiveAccount, useActiveWalletChain } from "thirdweb/react";
import { defaultMaalReserveUSDT, idToExplore, idToSymbol } from "../Web3/Constents";
import { postTransaction } from "../Web3/Axioscalls";


export default function Master({ selectedToken: parentSelectedToken = "ICUSD" }) {

  const {
    ninepercentreserve,
    setTotalS,
    totalS,
    disabledAction,
    setUpdate,
    burnAlownStatus,
  } = useContext(AppContext);


  const [mintamount, setMintamount] = useState('');
  const [burnamount, setBurnAmount] = useState(0);
  const [addminteraddress, setAddminteraddress] = useState("");
  const [addminteramount, setAddminteramount] = useState(0);
  const [removeminteraddress, setRemoveminteraddress] = useState("");
  const [selectedToken, setSelectedToken] = useState(parentSelectedToken);
  const [isBurn, setIsBurn] = useState(false)
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const account = useActiveAccount();
  const chain = useActiveWalletChain();

  // Sync with parent's selected token
  useEffect(() => {
    setSelectedToken(parentSelectedToken);
  }, [parentSelectedToken]);

  useEffect(()=>{
    setMintamount(ninepercentreserve - totalS)
  },[ninepercentreserve, totalS])


  const errors = (msg) => toast.error(msg);
  const sucess = (msg) => toast.success(msg);


  const MasterMinting = async (amount, userAddress) => {
    try {
      const data1 = await MintByMaster(amount, selectedToken, userAddress);
      console.log("data1",data1);
      if (data1.status) {
        postTransaction(data1?.transactionHash, "mintByMaster", amount, idToSymbol[`${chain.id}`] || "Unknown", idToExplore[`${chain.id}`] + `/tx/${data1.transactionHash}` || "N/A");
        const data = await Totak_Supply(selectedToken);
        setUpdate(2)
        setTotalS(data);
        sucess("Token Minted Successfully");
      }
      else{
        errors("Failed")
      }
    } catch (error) {
      console.log(error);
    }
  };

  const Burn_token = async (amount, userAddress) => {
    try {
      const data1 = await Burn(amount, selectedToken, userAddress);
      if (data1.status) {
        postTransaction(data1?.transactionHash, "burn", amount, idToSymbol[`${chain.id}`] || "Unknown", idToExplore[`${chain.id}`] + `/tx/${data1.transactionHash}` || "N/A");
        setUpdate(3)
        const data = await Totak_Supply(selectedToken);
        setTotalS(data);
        sucess("Token Burned Successfully");
      }
      else{
        errors("Failed")
      }
    } catch (error) {
      console.log(error);
    }
  };

  const add_minter = async () => {
    try {
      const data = await Add_Minter(addminteraddress, addminteramount, selectedToken, account?.address);
      if (data.status) {
        setUpdate(4)
        sucess("Minter Added Successfully");
      }
      else{
        errors("Failed")
      }
    } catch (error) {
      console.log(error);
    }
  };

  const remove_minter = async () => {
    try {
      const data = await Remove_Minter(removeminteraddress, selectedToken, account?.address);
      if (data.status) {
        setUpdate(5)
        sucess("Minter Removed Successfully");
      }
      else{
        errors("Failed")
      }
    } catch (error) {
      console.log(error);
    }
  };


  return (
    <Container className=" my-5">
      <Toaster />
      <div className="row">
        <div className="col-12 col-sm-6 col-md-3 m-y-1">
          <Form className="d-f f-d-c h-100">
            <Form.Group className="mb-3" controlId="formMint">
              <Form.Control
                type="number"
                placeholder={ninepercentreserve - totalS}
                value={mintamount}
                onChange={(e) => setMintamount(e.target.value)}
              />
            </Form.Group>
            <div className="m-t-a">
              <Button
                variant="primary"
                className=" "
                type="button"
                disabled={!account?.address || !burnAlownStatus }
                onClick={() => {
                  setIsBurn(false)
                  setOpen(true)
                }}
              >
                Master Mint
              </Button>
            </div>
          </Form>
        </div>
        <div className="col-12 col-sm-6 col-md-3 m-y-1  ">
          <Form className="d-f f-d-c h-100">
            <Form.Group className="mb-3" controlId="formAddAddress">
              <Form.Control
                type="text"
                placeholder="address"
                value={addminteraddress}
                onChange={(e) => setAddminteraddress(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formAddMinter">
              <Form.Control
                type="number"
                placeholder="0"
                value={addminteramount}
                onChange={(e) => setAddminteramount(e.target.value)}
              />
            </Form.Group>
            <div className="m-t-a">
              <Button
                variant="primary"
                className=""
                disabled={!account?.address || disabledAction}
                type="button"
                onClick={() => add_minter()}
              >
                Add Minter
              </Button>{" "}
            </div>
          </Form>
        </div>
        <div className="col-12 col-sm-6 col-md-3 m-y-1 ">
          <Form className="d-f f-d-c h-100">
            <Form.Group className="mb-3" controlId="formRemAddress">
              <Form.Control
                type="text"
                placeholder="address"
                value={removeminteraddress}
                onChange={(e) => setRemoveminteraddress(e.target.value)}
              />
            </Form.Group>
            <div className="m-t-a">
              <Button
                variant="primary"
                className=""
                type="button"
                disabled={!account?.address || disabledAction}
                onClick={() => remove_minter()}
              >
                Remove Minter
              </Button>{" "}
            </div>
          </Form>
        </div>
        <div className="col-12 col-sm-6 col-md-3 m-y-1 ">
          <Form className="d-f f-d-c h-100">
            <Form.Group className="mb-3" controlId="formBurn">
              <Form.Control
                type="number"
                placeholder="0"
                value={burnamount}
                onChange={(e) => setBurnAmount(e.target.value)}
              />
            </Form.Group>
            <div className="m-t-a">
              <Button
                variant="primary"
                className=""
                type="button"
                disabled={!account?.address || disabledAction}
                onClick={() => {
                  setIsBurn(true)
                  setOpen(true)
                  
                }}
              >
                Burn
              </Button>{" "}
            </div>
          </Form>
        </div>
        {/* <div className="col-md-3 my-4 my-md-0">
          <Form className="d-f f-d-c h-100">
            <Form.Group className="mb-3" controlId="formAdjCNH">
              <Form.Control
                type="number"
                placeholder="0"
                value={newCNH}
                onChange={(e) => setNewCNH(e.target.value)}
              />
            </Form.Group>
            <div className="m-t-a">
            <Button
              variant="primary"
              className=""
              type="button"
              onClick={() => updateNewCNH(newCNH)}
            >
              Adjust CNH
            </Button>
          </Form>
        </div> */}
      <MasterMnModal
        open={open}
        Mint_token={MasterMinting}
        Burn_token={Burn_token}
        handleClose={handleClose}
        setRequestedMintamount={setMintamount}
        setBurnAmount={setBurnAmount}
        mintburnallowd={ninepercentreserve - totalS}
        requestedamount={mintamount}
        requestedburn={burnamount}
        isburn={isBurn}
        setOpen={setOpen}
        isAutoSuggested={false}
      />
      </div>
    </Container>
  );
}
